import { render, staticRenderFns } from "./MovieCarousel.vue?vue&type=template&id=01d41880&"
import script from "./MovieCarousel.vue?vue&type=script&lang=js&"
export * from "./MovieCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports